module.exports = __webpack_public_path__ + "media/images/new_landing/people/karolina-borovska-6fc2ff215311c1428fee47e933dfe85b.jpeg";